import { render, staticRenderFns } from "./BlocoInforDadosGestao.vue?vue&type=template&id=5babf4ec&scoped=true&lang=pug"
import script from "./BlocoInforDadosGestao.vue?vue&type=script&lang=js"
export * from "./BlocoInforDadosGestao.vue?vue&type=script&lang=js"
import style0 from "./BlocoInforDadosGestao.vue?vue&type=style&index=0&id=5babf4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babf4ec",
  null
  
)

export default component.exports